var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-quick-action-button',{attrs:{"title":"Ubah","url":_vm.url,"icon":"pencil","disabled":_vm.disabled,"color":"primary"}})
}
var staticRenderFns = []

export { render, staticRenderFns }